import React from 'react'
import Header from '../Header/Header.tsx'
import { Box } from '@mui/material'
import Menue from '../Sidemenue/menue.tsx'
import { ToastContainer } from "react-toastify";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        // <Box  className='h-100 w-100 d-flex flex-column'  maxHeight={'100vh'} border={'2px solid green'}   display={{lg:'flex', md:'block'}}>
        //     <ToastContainer />
        //     <Box display={{xs:"none", lg:'block'}}><Menue/></Box> 
        //     <Box className='w-100' flex={1} border={'2px solid yellow'}>
        //         <Box position='sticky' className='w-100' zIndex={2}><Header></Header></Box>
        //         <Box className='w-100 body'>{children}</Box>
        //     </Box>
        //    <Box display={{xs:"block", lg:'none'}} height={'fit-content'} className='w-100' bgcolor='white'><Menue /></Box> 
        // </Box>
        <Box
            className='h-100 w-100 d-flex flex-column'
            maxHeight='100vh'
        >
            <ToastContainer />
            <Box className='d-flex'>
                {/* Top Menu (Desktop) */}
                <Box display={{ xs: 'none', lg: 'block' }}>
                    <Menue />
                </Box>

                {/* Header */}
                <Box className='w-100'>
                    <Box position="sticky" top={0} zIndex={2}>
                        <Header />
                    </Box>

                    {/* Scrollable Content Area */}
                    <Box
                        // display={'block'}
                        // className="w-100"
                        overflow="auto"
                    >
                        <Box className="body">{children}</Box>
                    </Box>
                </Box>
            </Box>

            {/* Bottom Menu (Mobile only, always visible) */}
            <Box
                display={{ xs: 'block', lg: 'none' }}
                position="sticky"
                bottom={0}
                className="w-100"
                bgcolor="white"
                zIndex={10}
                borderTop="1px solid #ccc"
            >
                <Menue />
            </Box>
        </Box>


    )
}

export default Layout
